import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH_M } from "constants/vp-sizes";
import { LG, LGR, MD, SM, XL, XS, XS_L, XS_M, XS_ML, XXL, XXS } from "constants/sizes";
import { titleFontSizes } from "./consts";
export const StyledTitle = styled.div`
  .core-title {
    font-size: 2.25rem;
    font-weight: 400;
    line-height: 48px;
    word-break: break-word;

    &.xss {
      font-size: ${titleFontSizes[XXS]};
      line-height: 32px;
      font-weight: 400;
    }

    &.xs_m {
      font-size: ${titleFontSizes[XS_M]};
      line-height: 32px;
      font-weight: 400;
    }

    &.xs_ml {
      font-size: ${titleFontSizes[XS_ML]};
      line-height: 32px;
      font-weight: 400;
    }

    &.xs_l {
      font-size: ${titleFontSizes[XS_L]};
      line-height: 32px;
      font-weight: 400;
    }

    &.xs {
      font-size: ${titleFontSizes[XS]};
      line-height: 32px;
      font-weight: 400;
    }

    &.sm {
      font-size: ${titleFontSizes[SM]};
      line-height: 40px;
      font-weight: 400;
    }

    &.md {
      font-size: ${titleFontSizes[MD]};
      line-height: 48px;
      font-weight: 400;
    }

    &.lg {
      font-size: ${titleFontSizes[LG]};
      line-height: 60px;
      font-weight: 700;
    }

    &.lgr {
      font-size: ${titleFontSizes[LGR]};
      line-height: 68px;
      font-weight: 700;
    }

    &.xl {
      font-size: ${titleFontSizes[XL]};
      line-height: 72px;
      font-weight: 700;
    }

    &.xxl {
      font-size: ${titleFontSizes[XXL]};
      line-height: 85px;
      font-weight: 700;
    }
  }

  .title-and-icon-wrapper {
    display: flex;

    .icon-wrapper {
      margin-right: 14px;
      display: flex;
      align-items: center;

      .picture-icon-wrapper {
        display: flex;
        height: 32px;

        .title-icon {
          height: 100%;
        }
      }

      &.xss {
        .picture-icon-wrapper {
          height: 8px;
        }
      }

      &.xs_m {
        .picture-icon-wrapper {
          height: 12px;
        }
      }

      &.xs {
        .picture-icon-wrapper {
          height: 18px;
        }
      }

      &.sm {
        .picture-icon-wrapper {
          height: 24px;
        }
      }

      &.md {
        .picture-icon-wrapper {
          height: 32px;
        }
      }

      &.lg {
        .picture-icon-wrapper {
          height: 38px;
        }
      }

      &.lgr {
        .picture-icon-wrapper {
          height: 44px;
        }
      }

      &.xl {
        .picture-icon-wrapper {
          height: 56px;
        }
      }

      &.xxl {
        .picture-icon-wrapper {
          height: 62px;
        }
      }

      &.lgr,
      &.xl,
      &.xxl {
        margin-right: 20px;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    /* Note: this descendant-combinator selector is a no-op in normal usage —
       .core-title-container is on the same Emotion-styled element as the
       generated parent class, so .core-title-container .core-title can't
       satisfy the descendant chain at the top level. Kept as-is so this
       PR is a strict no-op for any segment that wasn't already opted in
       via mobileTitleSize; revisit only as part of a dedicated cleanup. */
    .core-title-container .core-title {
      font-size: 2.25rem;
      line-height: 48px;
      font-weight: 400;

      &.md,
      &.lg {
        font-size: 1.75rem;
        line-height: 40px;
        font-weight: 700;
      }

      &.xl,
      &.lgr {
        font-size: 2.25rem;
        line-height: 48px;
        font-weight: 700;
      }

      &.xxl {
        font-size: 2.75rem;
        line-height: 48px;
        font-weight: 700;
      }
    }

    /* mobile-{size} classes are only added to the title element when
       a segment opts in via the mobileTitleSize advanced config prop.
       Targeted here directly (not under .core-title-container) so they
       actually match the rendered h1/h2 — this is the only path that
       gives editors a separate mobile size without affecting desktop. */
    .core-title.mobile-xss {
      font-size: ${titleFontSizes[XXS]};
      line-height: 32px;
    }

    .core-title.mobile-xs_m {
      font-size: ${titleFontSizes[XS_M]};
      line-height: 32px;
    }

    .core-title.mobile-xs_ml {
      font-size: ${titleFontSizes[XS_ML]};
      line-height: 32px;
    }

    .core-title.mobile-xs_l {
      font-size: ${titleFontSizes[XS_L]};
      line-height: 32px;
    }

    .core-title.mobile-xs {
      font-size: ${titleFontSizes[XS]};
      line-height: 32px;
    }

    .core-title.mobile-sm {
      font-size: ${titleFontSizes[SM]};
      line-height: 40px;
    }

    .core-title.mobile-md {
      font-size: ${titleFontSizes[MD]};
      line-height: 48px;
    }

    .core-title.mobile-lg {
      font-size: ${titleFontSizes[LG]};
      line-height: 60px;
    }

    .core-title.mobile-lgr {
      font-size: ${titleFontSizes[LGR]};
      line-height: 68px;
    }

    .core-title.mobile-xl {
      font-size: ${titleFontSizes[XL]};
      line-height: 72px;
    }

    .core-title.mobile-xxl {
      font-size: ${titleFontSizes[XXL]};
      line-height: 85px;
    }

    .title-and-icon-wrapper {
      .icon-wrapper {
        .picture-icon-wrapper {
          height: 32px;
        }

        &.md,
        &.lg,
        &.xl {
          .picture-icon-wrapper {
            height: 24px;
          }
        }
      }
    }
  }
`;
